import { getEnumValues } from "sprint-common-web";

export enum LanguageSpecificationType {
    Dictionary = 1,
    Sequential = 2
}

export const ensureLanguageSpecificationType: (number: number) => asserts number is LanguageSpecificationType = (
    number: number
) => {
    if (!getEnumValues(LanguageSpecificationType).includes(number)) {
        throw new Error("Incorrect language specification type.");
    }
};
